// extracted by mini-css-extract-plugin
export default {"image":"ConnectionTypeSelect_image__vk397","name":"ConnectionTypeSelect_name__imCH0"};